import { mapGetters } from 'vuex';
import appNotificationMixin from '@/mixins/appNotification';


export default {
  mixins: [
    appNotificationMixin,
  ],
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    }
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
};



// WEBPACK FOOTER //
// ./src/components/notification-items/notification-item-simple/notification-item-simple.js